import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import Divider from '@mui/material/Divider';

import InputImage from './InputImage.jsx';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: "50vw",
  bgcolor: '#242424',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

export default function AddImageModal() {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div>
      <Button onClick={handleOpen} style={{ color: "lightgray", background: "none", border: "1px solid rgb(187 146 35)", padding: "10px 20px" }}>
        <AddCircleOutlineIcon fontSize='small' style={{ marginRight: "0.6rem" }} />
        Add Image</Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2" style={{ color: "lightgray", fontWeight: "bold" }}>
            Add Image
          </Typography>
          <Divider sx={{ backgroundColor: 'lightgray', margin: "2rem 0" }} />
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            <InputImage chip_label="HTTP" text_label="Readonly input here" button_text="download file" />
            <InputImage chip_label="FTP" text_label="Readonly input here" button_text="download file" />
            <InputImage chip_label="SCP" text_label="Readonly input here" button_text="download file" />
            <InputImage chip_label="Browse" text_label="Browse your local file" button_text="upload file" />
          </Typography>
        </Box>
      </Modal>
    </div >
  );
}
